import { clearSession } from '../actions/auth';
export var session = function session(store) {
  return function (next) {
    return function (action) {
      var result = next(action);
      var error = action.error,
        payload = action.payload;
      if (error && (payload === null || payload === void 0 ? void 0 : payload.name) === 'OMSError' && (payload === null || payload === void 0 ? void 0 : payload.code) === 'UNAUTHORIZED') {
        store.dispatch(clearSession());
      }
      return result;
    };
  };
};